<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/introduction"><span class="toc-item-title-text cspan">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thedragonscat"><span class="toc-item-title-text cspan">The Dragon’s Cat</span></a></p>
<p class="toc-content toc-item-subtitle">Jody Lynn Nye</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/soburnusboth"><span class="toc-item-title-text cspan">So Burn Us Both</span></a></p>
<p class="toc-content toc-item-subtitle">Lisse Kirk</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/trialbycow"><span class="toc-item-title-text cspan">Trial by Cow</span></a></p>
<p class="toc-content toc-item-subtitle">Andrew Rucker Jones</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/blackwoodstomb"><span class="toc-item-title-text cspan">Blackwood’s Tomb</span></a></p>
<p class="toc-content toc-item-subtitle">Joseph Floyd</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/theritualistandthehedgewizard"><span class="toc-item-title-text cspan">The Ritualist and the Hedge-Wizard</span></a></p>
<p class="toc-content toc-item-subtitle">Kit Calvert</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/beneaththewingsofnight"><span class="toc-item-title-text cspan">Beneath the Wings of Night</span></a></p>
<p class="toc-content toc-item-subtitle">Ngo Binh Anh Khoa</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/kittenforsale"><span class="toc-item-title-text cspan">Kitten for Sale</span></a></p>
<p class="toc-content toc-item-subtitle">Aster Marsh</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thedreamer"><span class="toc-item-title-text cspan">The Dreamer</span></a></p>
<p class="toc-content toc-item-subtitle">M. Lalli Lassegard</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/aratarootandabigorangefruit"><span class="toc-item-title-text cspan">A Rat, a Root, and a Big Orange Fruit</span></a></p>
<p class="toc-content toc-item-subtitle">Zach Shephard</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/secondlife"><span class="toc-item-title-text cspan">Second Life</span></a></p>
<p class="toc-content toc-item-subtitle">Christina Sng</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thewitchinghourletters"><span class="toc-item-title-text cspan">The Witching Hour Letters</span></a></p>
<p class="toc-content toc-item-subtitle">Amanda Cecelia Lang &amp; Brittany Noelle</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thefamiliarsfamiliar"><span class="toc-item-title-text cspan">The Familiar’s Familiar</span></a></p>
<p class="toc-content toc-item-subtitle">Maegan Langer</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thecat"><span class="toc-item-title-text cspan">The Cat</span></a></p>
<p class="toc-content toc-item-subtitle">Sandy White</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/somespider"><span class="toc-item-title-text cspan">Some Spider</span></a></p>
<p class="toc-content toc-item-subtitle">Pines Callahan</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/scaryscaryskunk"><span class="toc-item-title-text cspan">Scary, Scary, Skunk</span></a></p>
<p class="toc-content toc-item-subtitle">Heather Graham</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/orphans" title="Link target outside of Sample"><span class="toc-item-title-text cspan">Orphans</span></span></p>
<p class="toc-content toc-item-subtitle">Matt Beswick</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thelastlifeofhildethesmall"><span class="toc-item-title-text cspan">The Last Life of Hilde the Small</span></a></p>
<p class="toc-content toc-item-subtitle">Jessica Feather</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/andhaveneverforgotten"><span class="toc-item-title-text cspan">“And Have Never Forgotten”*</span></a></p>
<p class="toc-content toc-item-subtitle">Mercedes Lackey</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/fluffy" title="Link target outside of Sample"><span class="toc-item-title-text cspan">Fluffy</span></span></p>
<p class="toc-content toc-item-subtitle">T. Chandler</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/earthbonding"><span class="toc-item-title-text cspan">Earth, Bonding</span></a></p>
<p class="toc-content toc-item-subtitle">Kerri J. Roe</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/notcommonafibonaccipoem"><span class="toc-item-title-text cspan">Not Common: A Fibonacci Poem</span></a></p>
<p class="toc-content toc-item-subtitle">Lois T. Bartholomew</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/thesecretofthesorceress"><span class="toc-item-title-text cspan">The Secret of the Sorceress</span></a></p>
<p class="toc-content toc-item-subtitle">Alexander Hay</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/sinkorswim"><span class="toc-item-title-text cspan">Sink or Swim</span></a></p>
<p class="toc-content toc-item-subtitle">Rebecca M. Senese</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/oldcrow"><span class="toc-item-title-text cspan">Old Crow</span></a></p>
<p class="toc-content toc-item-subtitle">Steve Rasnic Tem</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/tailend"><span class="toc-item-title-text cspan">Tail-End</span></a></p>
<p class="toc-content toc-item-subtitle">Lia Wu</p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/nameless" title="Link target outside of Sample"><span class="toc-item-title-text cspan">Nameless</span></span></p>
<p class="toc-content toc-item-subtitle">John G. Hartness</p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="toc-item-title-text cspan">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/abouttheexecutiveeditors"><span class="toc-item-title-text cspan">About the Executive Editors</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/ifyouenjoyedfeistyfelines"><span class="toc-item-title-text cspan">If You Enjoyed Feisty Felines</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="toc-content toc-item-title"><a href="#/copyrightinformation"><span class="toc-item-title-text cspan">Copyright Information</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?764f6a28